import React, { useEffect, useRef, useState } from "react";
import { Button, Container } from "reactstrap";

//Import Components
// Redux
import { Icon } from "@iconify/react/dist/iconify.js";
import { Grid, Stack } from "@mui/material";
import moment from "moment";
import { connect, useDispatch } from 'react-redux';
import AppDialog from "../../components/Common/AppDialog";
import Label from "../../components/Common/Label";
import Notification from "../../components/Common/Notification";
import PopOverFilter from "../../components/Common/PopoverFilter";
import SearchBar from "../../components/Common/Searchbar";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CustomButton from "../../components/Form/CustomButton";
import CustomSelect2 from "../../components/Form/CustomSelect2";
import CustomTextField from "../../components/Form/CustomTextField";
import Helpers from "../../helpers/helpers";
import { detailListingInquiry, getInquiryDetails, getInquiryListing, resetDashboardState, resetInquiryState, updateInquiry } from "../../store/actions";
import LoadingDialog from "../../components/Common/LoadingDialog";
import { set } from "date-fns";

const Inquiries = ({ inquiriesListing, leftSideBarType, details, updateInquiryArry, detailsListing }) => {
    const dispatch = useDispatch();

    const [loading, setIsLoading] = useState(false);
    const [detailsopen, setDetailsOpen] = useState(false);
    const [page, setPage] = useState(1);
    const [length, setLength] = useState("10");
    const [search, setSearch] = useState("");
    const [sort, setSorted] = useState("desc");
    const [sort_by, setSortBy] = useState("id");
    const [checkedAll, setCheckedAll] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const [remark, setRemark] = useState("");
    const [markSoldOpen, setMarkSoldOpen] = useState(false);
    const [markReservedOpen, setMarkReservedOpen] = useState(false);
    const [markClosedOpen, setMarkClosedOpen] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const searchRef = useRef(search);

    //filter
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [filterObject, setFilterObject] = useState({ position: 'all', status: 'all', type: 'all', advert_type: [], make: [], model: [], bike_type: [], licenseCategory: [] });


    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth); // Update state when window resizes
        };
        window.addEventListener("resize", handleResize);
        return (() => {
            window.removeEventListener("resize", handleResize); // Cleanup on unmount
        })
    }, []);

    useEffect(() => {
        initData();
    }, [length, page, sort, sort_by]);

    useEffect(() => {
        if (updateInquiryArry?.code === "success") {
            setNotification({
                open: true,
                msg: "Inquiry updated successfully",
                type: "success",
            });
            setRemark("");
            dispatch(resetInquiryState())
            dispatch(getInquiryDetails({ id: details?.id }))
            initData();
            dispatch(detailListingInquiry({ id: details?.id, paginate: 0, type: "remarks" }))
            setMarkClosedOpen(false);
            setMarkReservedOpen(false);
            setMarkSoldOpen(false);
        } else if (updateInquiryArry?.code === "invalid_field" || updateInquiryArry?.code === "error" || updateInquiryArry?.code === "unauthenticated" || updateInquiryArry?.code === "login_needed" || updateInquiryArry?.code === "ivalid") {
            setNotification({
                open: true,
                msg: updateInquiryArry?.message || "Error",
                type: "error",
            });
        }
    }, [updateInquiryArry])

    useEffect(() => {
        searchRef.current = search || '';
    }, [search]);

    const header = [
        {
            Header: "Date / Time",
            accessor: (cellProps) => {
                return (cellProps?.created_at || "-")
            },
        },
        {
            Header: "Name",
            accessor: (cellProps) => {
                return (cellProps?.seller_name || "-")
            },
        },
        {
            Header: "Listing Type",
            accessor: (cellProps) => {
                return (cellProps?.type ? cellProps.type.charAt(0).toUpperCase() + cellProps.type.slice(1) : "-")
            },
        },

        {
            Header: "Listing",
            accessor: (cellProps) => {
                return (cellProps?.bike_advert?.info?.title || "-")
            },
        },
        {
            Header: "Listing Status",
            accessor: (cellProps) => {
                return (cellProps?.bike_advert && cellProps?.bike_advert?.bike_advert_type ? <Label.GeneralStatusLabel label={cellProps.bike_advert?.status} list={Helpers.advertStatus} /> : "-")
            },
        },
        {
            Header: "Inquired Salesman",
            accessor: (cellProps) => {
                return (cellProps?.inquired_to || "-")
            },
        },
        {
            Header: "Inquiries Status",
            accessor: (cellProps) => {
                return (cellProps?.status ? <Label.GeneralStatusLabel label={cellProps.status} list={Helpers.advertStatus} /> : "-")
            },
        },
    ]

    const headerDetails = [
        {
            Header: "Date",
            accessor: (cellProps) => {
                return (cellProps?.created_at || "-")
            },
        },
        {
            Header: "Remarks / Notes",
            accessor: (cellProps) => {
                return (cellProps?.remark || "-")
            },
        },
    ]

    const initData = () => {
        let payload = {
            size: length || "",
            paginate: page || "",
            search: searchRef.current || "",
            sort_order: sort || "",
            sort_by: sort_by || "",
            status: filterObject?.status === "all" ? "" : filterObject?.status || "",
            type: filterObject?.type === "all" ? "" : filterObject?.type || "",
            // date_range: filterObject?.createdDate ? `${filterObject.createdDate.from},${filterObject.createdDate.to}` : "",
            created_at_from: filterObject?.from ? moment(filterObject?.from, "DD/MM/YYYY")?.format?.("YYYY/MM/DD") : "",
            created_at_to: filterObject?.to ? moment(filterObject?.to, "DD/MM/YYYY")?.format?.("YYYY/MM/DD") : "",
        }
        dispatch(getInquiryListing(payload));
    }

    const getLengthPage = (page, length) => {
        setPage(page)
        setLength(length)
    }

    const resetFilter = () => {
        setSortBy("")
        setSorted("")
        setPage((prevPage) => (prevPage === 1 ? '1' : 1));
        setFilterObject({ status: "all", type: "all", advert_type: [], make: [], model: [], bike_type: [], licenseCategory: [] })
        setStartDate("");
        setEndDate("");
        setSearch(""); // Clear search keyword
        searchRef.current = ""; // Update searchRef
    }

    const applyFilter = (sort, sortBy) => {
        setSortBy(sortBy || 'id');
        setSorted(sort || 'desc');
        setPage(page === 1 ? '1' : 1);
        setDrawerOpen(false);
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                initData();
            }
        }, Helpers.searchInterval);
    }

    const handleSubmitRemarks = () => {
        if (!remark) {
            setNotification({
                open: true,
                msg: "Please enter remarks before submitting.",
                type: "error",
            });
        } else {
            dispatch(updateInquiry({ id: details?.id, data: { action: "add_remark", remark: remark } }))
        }
    }

    const renderUserInfo = (title, value) => {
        return (
            <Grid item md={3} sm={6} xs={12}>
                <div className="subheader-2">{title}</div>
                <div className="text-bold font-size-18">{value || '0'}</div>
            </Grid>
        )
    }

    const typeList = [{ value: "motorcycles", label: "Motorcycles" }, { value: "accessories", label: "Accessories" },]
    const statusList = [{ value: "new", label: "New" }, { value: "closed", label: "Closed" },]

    const filterList2 = [
        {
            label: "Inquiry Status",
            type: "checkbox",
            value: filterObject?.status || [],
            data: statusList || [],
            xsGrid: 12,
            mdGrid: 12,
            onChange: (e, item) => {
                setFilterObject((prevValues) => ({
                    ...prevValues,
                    status: e,
                }))
            }
        },
        {
            label: "Inquiry Date",
            value: filterObject?.createdDate,
            type: "date_range",
            startPlaceholder: "From",
            endPlaceholder: "To",
            startDateTitle: "From",
            startDate: startDate,
            setStartDate: (date) => {
                setStartDate(date);
                const formattedDate = date ? moment(date).format('DD/MM/YYYY') : "";
                setFilterObject((prev) => ({ ...prev, from: formattedDate }));
            },
            endDateTitle: "To",
            endDate: endDate,
            setEndDate: (date) => {
                setEndDate(date);
                const formattedDate = date ? moment(date).format('DD/MM/YYYY') : "";
                setFilterObject((prev) => ({ ...prev, to: formattedDate }));
            },
            xsGrid: 12, smGrid: 12, mdGrid: 12
        },
        {
            label: "Listing Type",
            type: "checkbox",
            value: filterObject?.type || [],
            data: typeList || [],
            xsGrid: 12,
            mdGrid: 12,
            onChange: (e, item) => {
                setFilterObject((prevValues) => ({
                    ...prevValues,
                    type: e,
                }))
            }
        },
    ]

    const customToolsBar = () => {
        return (
            <Grid container item sm={12} md={12} mt={4} style={{ display: 'flex', alignItems: "center" }} spacing={1} mb={1}>
                <Grid item lg={4} md={4} sm={4} xs={12} className="d-flex">
                    <SearchBar
                        value={search}
                        setValue={(e) => handleSearch(e)}
                        module={"name or vehicle"}
                    />
                </Grid>
                <Grid item lg={2} md={2.8} sm={2.5} xs={6} className="mt-2">
                    <CustomSelect2
                        values={filterObject?.status || "-1"}
                        onChange={(e) => {
                            setFilterObject((prevValues) => ({
                                ...prevValues,
                                status: e
                            }))
                            setPage((prevPage) => (prevPage === 1 ? '1' : 1));
                        }}
                        data={[{ value: "all", label: "All" }, ...statusList]}
                        placeholder={`All`}
                        startAdornment={<div className="subheader-2" style={{ marginRight: 5 }}>Status: </div>}
                        height={35}
                    />
                </Grid>

                <Grid item lg={2} md={2.8} sm={2.5} xs={6} className="mt-2">
                    <CustomSelect2
                        values={filterObject?.type || "-1"}
                        onChange={(e) => {
                            setFilterObject((prevValues) => ({
                                ...prevValues,
                                type: e
                            }))
                            setPage((prevPage) => (prevPage === 1 ? '1' : 1));
                        }}
                        data={[{ value: "all", label: "All" }, ...typeList]}
                        placeholder={'All'}
                        startAdornment={<div className="subheader-2" style={{ marginRight: 5 }}>Type: </div>}
                        height={35}
                    />
                </Grid>

                <Grid item lg={1.8} md={2.5} sm={2.5} xs={6} className="d-flex align-items-center">
                    <PopOverFilter
                        setDialogOpen={setDrawerOpen}
                        open={drawerOpen}
                        applyFilter={applyFilter}
                        filterData={filterList2}
                        setFilterObject={setFilterObject}
                        sort={sort}
                        sort_by={sort_by}
                        handleResetFilter={resetFilter}
                    />
                </Grid>

                <Grid item lg={2} md={2} sm={2} xs={12} className="d-flex align-items-center">
                    <CustomButton
                        title={<div style={{ textDecorationLine: 'underline' }}>Clear all</div>}
                        press={() => resetFilter()}
                        height={32}
                        backgroundColor={'transparent'}
                        textColor={'#B48A3C'}
                        borderStyle={'none'}
                    />
                </Grid>
            </Grid>
        )
    }

    const renderContent = () => {
        if (detailsopen) {
            return <>
                <Stack spacing={2} direction="row" alignItems="center">
                    <img src={details?.bike_advert?.thumbnail_base64 || Helpers.noImage} alt="inquiry details" height="53px" width="64px" />
                    <Stack spacing={1}>
                        <span style={{ fontWeight: 600, fontSize: "16px" }}>{details?.bike_advert?.info?.title || '-'}
                            <Label.GeneralStatusLabel label={details?.is_reserved} list={Helpers.advertStatus} />
                        </span>
                        <div className="column">
                            <span style={{ fontSize: "14px", color: "#808588", marginLeft: 5 }}>{details?.bike_advert?.price} {details?.bike_advert?.rate}</span>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <Label.GeneralStatusLabel label={details?.status} list={Helpers.advertStatus} />
                            <Label.GeneralStatusLabel label={details?.bike_advert?.status} list={Helpers.advertStatus} />
                            <span className="text-muted" style={{ marginLeft: 5 }}>Stock ID: <span>{details?.bike_advert?.display_id || '-'}</span></span>
                        </div>
                    </Stack>
                </Stack>
                <Stack className="pt-4" spacing={1.5}>
                    <span style={{ fontWeight: 600, fontSize: 14 }}>Inquiry Summary</span>
                    <Stack direction="row" justifyContent={"space-between"}>
                        <span className="text-muted">User</span>
                        <span className="text-muted">{details?.requestor?.name || '-'} <span className="clickable-text" style={{ textDecoration: "underline" }}><a style={{ color: "#B48A3C" }} href={`tel:${details?.requestor?.phone || ""}`}>+{details?.requestor?.phone || "-"}</a></span></span>
                    </Stack>
                    <Stack direction="row" justifyContent={"space-between"}>
                        <span className="text-muted">Dealer / Seller</span>
                        <span className="text-muted">{details?.seller_name || '-'} </span>
                    </Stack>
                    <Stack direction="row" justifyContent={

                        "space-between"}>
                        <span className="text-muted">Date of Inquiry</span>
                        <span className="text-muted">{details?.created_at || '-'} </span>
                    </Stack>
                </Stack>
                <div className="pt-3">
                    <span style={{ fontWeight: 600, fontSize: 14 }}>Remarks / Notes</span>
                    <Table
                        header={headerDetails}
                        data={detailsListing?.data || []}
                        pageSize={length}
                        totalPage={detailsListing?.last_page}

                    />
                    <CustomTextField
                        values={remark}
                        placeholder={"Remarks / Notes"}
                        multiline={true}
                        rows={4}
                        onChange={(e) => setRemark(e)}
                    />
                    <div className="pt-3">
                        <CustomButton
                            title={"Submit"}
                            press={() => handleSubmitRemarks()}
                        />
                    </div>

                </div>

            </>
        } else if (markClosedOpen) {
            return <>
                <span className="pb-2">Are you sure you want to mark this listing as closed?</span>
            </>
        } else if (markReservedOpen) {
            return <>
                <span className="pb-2">Are you sure you want to mark this listing as reserved?</span>
            </>

        } else if (markSoldOpen) {
            return <>
                <span className="pb-2">Are you sure you want to mark this listing as Sold?</span>
                <span className="pb-2">Once marked as Sold:</span>
                <ul>
                    <li>The listing will no longer appear on the marketplace.</li>
                    <li>Buyers can no longer contact you via WhatsApp or inquiry.</li>
                    <li>You can still view this advert under your Sold Listings tab.</li>
                    <li>This action can be reversed later if the sale falls through.</li>
                </ul>
            </>
        }
    }

    const renderContentAction = () => {
        if (markClosedOpen) {
            return <>
                <span className="pb-2">Are you sure you want to mark this listing as closed?</span>
            </>
        } else if (markReservedOpen) {
            return <>
                <span className="pb-2">Are you sure you want to mark this listing as reserved?</span>
            </>

        } else if (markSoldOpen) {
            return <>
                <span className="pb-2">Are you sure you want to mark this listing as Sold?</span>
                <span className="pb-2">Once marked as Sold:</span>
                <ul>
                    <li>The listing will no longer appear on the marketplace.</li>
                    <li>Buyers can no longer contact you via WhatsApp or inquiry.</li>
                    <li>You can still view this advert under your Sold Listings tab.</li>
                    <li>This action can be reversed later if the sale falls through.</li>
                </ul>
            </>
        }
    }

    const handleAction = () => {
        if (markClosedOpen) {
            dispatch(updateInquiry({ id: details?.id, data: { action: "update_status", status: "closed" } }))
        } else if (markReservedOpen) {
            dispatch(updateInquiry({ id: details?.id, data: { action: "update_status", status: "reserved" } }))
        } else if (markSoldOpen) {
            dispatch(updateInquiry({ id: details?.id, data: { action: "update_status", status: "sold" } }))
        }
    }

    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: width <= 768 && leftSideBarType === 'condensed' ? 72 : 0 }}>
                <LoadingDialog open={loading || !inquiriesListing} />
                <Notification notification={notification} setNotification={setNotification} />
                <Container fluid style={{}}>
                    <div style={{ marginBottom: "50px" }} className="header-2 d-flex align-items-center">Inquiries <div className="header-amount mx-2">{inquiriesListing?.data?.total || 0}</div></div>
                    <div className="mt-3 dashboard-card">
                        <Grid container spacing={2}>
                            {renderUserInfo('Total Inquiries', inquiriesListing?.counts?.total_counts || 0)}
                            {renderUserInfo('New Inquiries', inquiriesListing?.counts?.new_counts || 0)}
                            {renderUserInfo('Motorcycle Inquiries', inquiriesListing?.counts?.total_bike_adverts || 0)}
                            {renderUserInfo('Accessory Inquiries', inquiriesListing?.counts?.total_bike_accessories || 0)}
                        </Grid>
                    </div>
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={inquiriesListing?.data?.data || []}
                        pageSize={length}
                        totalPage={inquiriesListing?.data?.last_page}
                        getLengthPage={getLengthPage}
                        customToolsBar={true}
                        setCheckedAll={setCheckedAll}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                        checkedAll={checkedAll}
                        sort={sort}
                        onTableRowClick={(row) => { setDetailsOpen(true); dispatch(detailListingInquiry({ id: row.id, paginate: 0, type: "remarks" })); dispatch(getInquiryDetails({ id: row.id, paginate: 0 })); }}
                    />
                    <TablePageControl
                        from={inquiriesListing?.data?.from || 0}
                        to={inquiriesListing?.data?.to || 0}
                        total={inquiriesListing?.data?.total || 0}
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={inquiriesListing?.data?.last_page || 1}
                    />
                </Container>
            </div >
            <AppDialog
                title={'Inquiry Details'}
                open={detailsopen}
                hideCloseIcon={false}
                isMobile={width <= 768 ? true : false}
                close={() => { setDetailsOpen(false); setRemark(""); dispatch(resetInquiryState()) }}
                dialogActionStyle={{ display: 'flex', justifyContent: 'space-between', width: "100%" }}
                customTitle={
                    <Stack direction={{ xs: "column", sm: "column", md: 'row' }} spacing={2} justifyContent={"space-between"} width={"100%"}>
                        <CustomButton
                            title={<><Icon icon={'mingcute:whatsapp-fill'} style={{ marginRight: 5, color: '#59C825', height: "14px", width: "14px" }} />Contact Buyer</>}
                            press={() => window.open(details?.requestor?.whatsapp_url, '_blank')}
                            height={32}
                            backgroundColor={'white'}
                            textColor={'#000'}
                            borderStyle={"1px solid #E2E2E2"}
                            width={width <= 768 && '100%'}
                        />
                        <div className={width <= 768 && "d-flex align-items-center"}>
                            {(details?.status === "new" || details?.status === "reserved") &&
                                <>
                                    <CustomButton
                                        title={<><Icon icon={'ri:price-tag-line'} style={{ marginRight: 5, color: '#B48A3C', height: "14px", width: "14px" }} />Mark as closed</>}
                                        press={() => { setMarkClosedOpen(true) }}
                                        height={32}
                                        backgroundColor={'#B48A3C1A'}
                                        textColor={'#B48A3C'}
                                        borderStyle={"1px solid #B48A3C1A"}
                                        // marginRight={"10px"}
                                        width={width <= 768 && '50%'}
                                    />

                                    <span style={{ borderRight: "1px solid #E2E2E2", height: "32px", margin: "0 10px" }}></span>
                                </>
                            }
                            {(details?.status === "new") && <CustomButton
                                title={<><Icon icon={'ri:price-tag-line'} style={{ marginRight: 5, color: '#000', height: "14px", width: "14px" }} />Mark as reserved</>}
                                press={() => { setMarkReservedOpen(true) }}
                                height={32}
                                backgroundColor={'#F5F5F5'}
                                textColor={'#000'}
                                borderStyle={"1px solid #F5F5F5"}
                                marginRight={"10px"}
                                width={width <= 768 && '50%'}
                            />}
                            {(details?.status === "new" || details?.status === "reserved") && <CustomButton
                                title={<><Icon icon={'ri:check-fill'} style={{ marginRight: 5, color: 'white', height: "14px", width: "14px" }} />Mark as sold</>}
                                press={() => { setMarkSoldOpen(true) }}
                                height={32}
                                backgroundColor={'#27C840'}
                                textColor={'white'}
                                borderStyle={"1px solid #27C840"}
                                width={width <= 768 && '50%'}
                            />}

                        </div>
                    </Stack>
                }
                width={'70%'}
            >
                {renderContent()}

            </AppDialog>
            <AppDialog
                title={markClosedOpen ? 'Mark as Closed' : markReservedOpen ? 'Mark as Reserved' : markSoldOpen ? 'Mark as Sold' : ''}
                open={markClosedOpen || markReservedOpen || markSoldOpen}
                isMobile={width <= 768 ? true : false}
                close={() => { setMarkClosedOpen(false); setMarkReservedOpen(false); setMarkSoldOpen(false); dispatch(resetInquiryState()) }}
                dialogActionStyle={{ display: 'flex', justifyContent: 'flex-end', width: "100%" }}
                customTitle={
                    <div style={{ justifyContent: "flex-end", display: "flex" }}>
                        <Stack
                            justifyContent={'center'}
                            direction={"row"}
                            gap={2}
                            sx={{ width: "100%", mt: 1, mb: 1 }} // Ensure the Stack takes full width
                        >
                            <Button
                                onClick={(e) => { setMarkClosedOpen(false); setMarkReservedOpen(false); setMarkSoldOpen(false); dispatch(resetInquiryState()) }}
                                style={{
                                    color: '#808588',
                                    borderRadius: "20px",
                                    backgroundColor: '#F9F9F9',
                                    border: '1px solid #F9F9F9',
                                    width: "100%", // Ensure button width is determined by content
                                    padding: 20,
                                    height: 42
                                }}
                                className="me-1 modal-negative-button"
                                type="submit"
                            >
                                {'Cancel'}
                            </Button>
                            <Button
                                color="primary"
                                className="modal-positive-button"
                                style={{
                                    color: "white",
                                    borderRadius: "20px",
                                    backgroundColor: "black",
                                    border: "1px solid black",
                                    width: "100%", // Ensure button width is determined by content
                                    padding: 20,
                                    height: 42
                                }}
                                type="submit"
                                onClick={(e) => handleAction()}
                            >
                                <span style={{ whiteSpace: "nowrap" }}>{markSoldOpen ? 'Mark as Sold' : markClosedOpen ? 'Mark as Closed' : markReservedOpen ? 'Mark as Reserved' : ''}</span>
                            </Button>
                        </Stack>
                    </div>
                }
                width={'50%'}
            >
                {renderContentAction()}

            </AppDialog>
            {/* <Footer></Footer> */}
        </React.Fragment >
    );

}

function mapStateToProps({ Login, Inquiry, Layout }) {
    return {
        userPermission: Login.permissionArry,
        inquiriesListing: Inquiry?.inquiryListing,
        details: Inquiry?.inquiryDetails,
        detailsListing: Inquiry?.detailListingInquiry?.data,
        updateInquiryArry: Inquiry?.updateInquiry,
        leftSideBarType: Layout.leftSideBarType,
    };
}

// export default withRouter(connect(null, { verify_admin, getDashboardInfo })(Dashboard));
export default connect(mapStateToProps)(Inquiries);
